import { NAP } from "@/lib/nap";

// FAQ data is duplicated here (kept in sync with src/components/faq/index.jsx)
// so the homepage JSON-LD is self-contained and SEO-critical FAQ rich results
// emit even when the React tree is hydrating client-side.
const FAQ_PAIRS = [
  {
    q: "Which is the best real estate developer in Nagpur?",
    a: "Siddhivinayak Group is widely regarded as one of Nagpur's most trusted real estate developers. Backed by the Kunal Padole Group with 16+ years of leadership and MahaRERA registration (P50500078967), the developer delivers premium 2 & 3 BHK flats, plotted developments, and townships across Ram Nagar, Hanuman Nagar, Narsala, Bahadura, and Ambazari.",
  },
  {
    q: "Does Siddhivinayak Group offer RL plots in Nagpur?",
    a: "Yes. Siddhivinayak Nagari by Siddhivinayak Group is a RERA-approved RL plot layout in Bahadura, Nagpur, offering 21 well-planned residential plots with 9-metre cement concrete roads, underground electric network, transformer, and a sewage treatment plant. Plots are ready for registry and construction.",
  },
  {
    q: "Are Siddhivinayak Group projects suitable for property investment?",
    a: "Yes. Projects are located in Nagpur's high-growth corridors — Ram Nagar, Hanuman Nagar, Narsala, and Bahadura — that benefit from Metro Phase-2 expansion, the MIHAN SEZ, and Smart City infrastructure. Hilltop Heights -14 carries RERA No. P50500078967, with possession expected from December 2026 onwards.",
  },
  {
    q: "What types of residential properties does Siddhivinayak Group offer?",
    a: "Siddhivinayak Group offers four residential formats: premium 2 BHK flats (Hilltop Heights -14), 2 & 3 BHK apartments with duplex penthouses (Hilltop Heights -11, Embassy-10), RERA-approved RL plots (Siddhivinayak Nagari), and large-scale residential townships (Ayodhya City in Narsala).",
  },
  {
    q: "Why is Nagpur a smart city for real estate investment?",
    a: "Nagpur is India's third Smart City under the SCM, hosts the MIHAN multi-modal international hub, and is on the Mumbai–Nagpur Samruddhi Expressway corridor. Combined with the operational Metro Phase-1 and an approved Phase-2, the city delivered 11–14% CAGR residential price growth between 2020 and 2025, making it a top-tier Tier-2 investment destination.",
  },
  {
    q: "What is the price of 2 BHK flats in Nagpur?",
    a: "2 BHK flats in Nagpur's premium corridors (Ram Nagar, Hanuman Nagar, Ambazari) currently range between ₹45 lakh and ₹85 lakh depending on location, floor, and amenities. Siddhivinayak Group's Hilltop Heights -14 in Ram Nagar falls in the mid-premium band with MahaRERA pricing transparency.",
  },
  {
    q: "Is Siddhivinayak Group RERA registered?",
    a: "Yes. Hilltop Heights -14 is registered with MahaRERA under registration number P50500078967. The project page on the official MahaRERA portal (maharera.mahaonline.gov.in) carries the complete project disclosure, layout plans, and quarterly progress updates as required by law.",
  },
  {
    q: "Which areas in Nagpur are best to buy a home?",
    a: "Five localities currently lead Nagpur's residential growth: Ram Nagar (Hilltop) for premium hill-view flats near Ambazari Lake, Hanuman Nagar for connectivity near Krida Square, Narsala for upcoming Ayodhya City township, Bahadura for affordable RL plots, and Ambazari Layout for established family neighbourhoods. All five are covered by Siddhivinayak Group projects.",
  },
  {
    q: "How do I book a site visit for Siddhivinayak projects?",
    a: "Book a free site visit in three steps: (1) call +91 98232 60303 or email mail@kunalpadole.com, (2) share the project name (Hilltop Heights -14, -11, Embassy-10, Siddhivinayak Nagari, or Ayodhya City), (3) pick a 60-minute slot — Saturday and Sunday slots are available, and a project consultant will accompany you on-site.",
  },
  {
    q: "Does Siddhivinayak Group assist with home loans?",
    a: "Yes. Siddhivinayak Group has tie-ups with leading banks and housing finance companies (HFCs) including SBI, HDFC, ICICI, and LIC HFL. Pre-approved loan offers are available for select inventory, and the in-house team assists with documentation, eligibility checks, and disbursement at zero extra cost to the buyer.",
  },
  {
    q: "What documents are required to buy a flat in Nagpur?",
    a: "For an RERA-registered project like Hilltop Heights -14, you need: PAN card, Aadhaar, last 6 months' bank statements, 2 passport photographs, address proof of current residence, and a cancelled cheque. NRI buyers additionally need a passport copy, PIO/OCI card, and a notarised POA if purchasing through a representative.",
  },
  {
    q: "What is the difference between RL plots and apartments in Nagpur?",
    a: "RL (Revenue Layout) plots are NA-ordered, government-approved residential plots with road, drainage, and utility infrastructure — buyers construct their own home at their pace. Apartments are ready-to-move-in, multi-storey units with shared amenities like lifts, security, and parking. Siddhivinayak Group offers both: Siddhivinayak Nagari (RL plots in Bahadura) and Hilltop Heights series (apartments).",
  },
  {
    q: "When is the possession of Hilltop Heights -14?",
    a: "Hilltop Heights -14 (RERA No. P50500078967) has a tentative possession date of December 2026. Siddhivinayak Group issues quarterly construction updates through the MahaRERA portal and direct buyer communications; pre-handover inspections are scheduled 90 days before the possession date.",
  },
  {
    q: "Who is the founder of Siddhivinayak Group?",
    a: "Dr. Kunal G. Padole, an MBA and Ph.D. in Management with 16+ years of entrepreneurial experience, founded Siddhivinayak Infrastructure — the venture behind Siddhivinayak Group. Under his leadership, the group has expanded into real estate, education, and social initiatives, positively impacting lakhs of lives across Central India.",
  },
  {
    q: "How can I verify Siddhivinayak Group's track record before buying?",
    a: "Verify on four official channels: (1) MahaRERA portal for project registration and quarterly progress, (2) MCA portal for the company's CIN and director details, (3) GST portal for active GSTIN status, and (4) on-site visits to delivered projects such as completed phases of the Hilltop Heights series. Customer testimonials are also published on the official website.",
  },
];

const PROJECTS = [
  {
    name: "Hilltop Heights - 14",
    slug: "hilltop-heights-14",
    street: "Ram Nagar",
    locality: "Nagpur",
  },
  {
    name: "Hilltop Heights - 11",
    slug: "hilltop-heights-11",
    street: "Hilltop Layout, Ambazari",
    locality: "Nagpur",
  },
  {
    name: "Siddhivinayak Embassy - 10",
    slug: "embassy-10",
    street: "Hanuman Nagar, Near Krida Square",
    locality: "Nagpur",
  },
  {
    name: "Siddhivinayak Nagari",
    slug: "siddhivinayak-nagari",
    street: "Bahadura",
    locality: "Nagpur",
  },
  {
    name: "Ayodhya City",
    slug: "ayodhya-city",
    street: "Narsala",
    locality: "Nagpur",
  },
];

const ORG_ID = `${NAP.siteUrl}/#organization`;
const LOCAL_ID = `${NAP.siteUrl}/#localbusiness`;
const SITE_ID = `${NAP.siteUrl}/#website`;
const FAQ_ID = `${NAP.siteUrl}/#faq`;
const LOGO_URL = `${NAP.siteUrl}/img/logo.svg`;
const OG_IMAGE = `${NAP.siteUrl}/img/og/siddhivinayak-group-og.jpg`;

const areaServed = [
  { "@type": "City", name: "Nagpur" },
  { "@type": "Place", name: "Ram Nagar" },
  { "@type": "Place", name: "Hanuman Nagar" },
  { "@type": "Place", name: "Narsala" },
  { "@type": "Place", name: "Bahadura" },
  { "@type": "Place", name: "Ambazari" },
];

const organization = {
  "@type": ["Organization", "RealEstateAgent"],
  "@id": ORG_ID,
  name: NAP.brand,
  alternateName: NAP.legalName,
  url: NAP.siteUrl,
  logo: LOGO_URL,
  description:
    "Trusted real estate developer in Nagpur (Kunal Padole Group) — premium 2 & 3 BHK flats, townships, and RERA-approved RL plots across Ram Nagar, Hanuman Nagar, Narsala, Bahadura, and Ambazari.",
  telephone: NAP.phone,
  email: NAP.email,
  foundingDate: "2009",
  areaServed,
  parentOrganization: { "@type": "Organization", name: NAP.parentGroup },
  address: {
    "@type": "PostalAddress",
    streetAddress: NAP.streetAddress,
    addressLocality: NAP.addressLocality,
    addressRegion: NAP.addressRegion,
    postalCode: NAP.postalCode,
    addressCountry: NAP.addressCountry,
  },
};

const localBusiness = {
  "@type": "LocalBusiness",
  "@id": LOCAL_ID,
  name: NAP.brand,
  image: OG_IMAGE,
  telephone: NAP.phone,
  priceRange: "₹₹",
  address: {
    "@type": "PostalAddress",
    streetAddress: NAP.streetAddress,
    addressLocality: NAP.addressLocality,
    addressRegion: NAP.addressRegion,
    postalCode: NAP.postalCode,
    addressCountry: NAP.addressCountry,
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: NAP.geo.lat,
    longitude: NAP.geo.lng,
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      opens: "10:00",
      closes: "19:00",
    },
  ],
  parentOrganization: { "@id": ORG_ID },
};

const website = {
  "@type": "WebSite",
  "@id": SITE_ID,
  url: NAP.siteUrl,
  name: NAP.brand,
  publisher: { "@id": ORG_ID },
  inLanguage: "en-IN",
  potentialAction: {
    "@type": "SearchAction",
    target: `${NAP.siteUrl}/blog?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

const faqPage = {
  "@type": "FAQPage",
  "@id": FAQ_ID,
  mainEntity: FAQ_PAIRS.map(({ q, a }) => ({
    "@type": "Question",
    name: q,
    acceptedAnswer: { "@type": "Answer", text: a },
  })),
};

const breadcrumb = {
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: NAP.siteUrl,
    },
  ],
};

const itemList = {
  "@type": "ItemList",
  itemListElement: PROJECTS.map((p, i) => ({
    "@type": "ListItem",
    position: i + 1,
    item: {
      "@type": "Residence",
      name: p.name,
      url: `${NAP.siteUrl}/projects/${p.slug}`,
      address: {
        "@type": "PostalAddress",
        streetAddress: p.street,
        addressLocality: p.locality,
        addressRegion: "Maharashtra",
        addressCountry: "IN",
      },
    },
  })),
};

export const HOME_SCHEMA = {
  "@context": "https://schema.org",
  "@graph": [
    organization,
    localBusiness,
    website,
    faqPage,
    breadcrumb,
    itemList,
  ],
};
